/** Color chips for CMS programme Tags (Kentico). */
export function programmeTagClass(tag: string): string {
  const s = tag.toLowerCase();
  if (/пленар|plenary|keynote/.test(s)) return "bg-blue-100 text-blue-800";
  if (/панел|panel|кругл|roundtable/.test(s)) return "bg-purple-100 text-purple-800";
  if (/мастер|master|воркшоп|workshop/.test(s)) return "bg-amber-100 text-amber-800";
  if (/конкурс|contest|награжд|award|championship/.test(s)) return "bg-rose-100 text-rose-800";
  if (/практическ|конференц|practical conference/.test(s)) return "bg-teal-100 text-teal-800";
  if (/впервые|first time|^new$/.test(s)) return "bg-emerald-100 text-emerald-800";
  if (/нетворк|network|фуршет|коктейл/.test(s)) return "bg-pink-100 text-pink-800";
  // Brand / exhibition labels (Testing&Control, NDT RUSSIA, …)
  return "bg-slate-100 text-slate-700";
}

/** Fallback EN labels when API still returns RU CMS tags. */
const PROGRAMME_TAG_EN: Record<string, string> = {
  "пленарная сессия": "Plenary Session",
  "панельная сессия": "Panel Session",
  "впервые в программе": "First time",
  конкурс: "Contest",
  "мастер-класс": "Masterclass",
  "церемония награждения": "Award Ceremony",
  "практическая конференция": "Practical Conference",
  "круглый стол": "Roundtable",
};

export function localizeProgrammeTag(tag: string, lang: string): string {
  if (!lang.toLowerCase().startsWith("en")) return tag;
  const key = tag.trim().toLowerCase().replace(/^["«]|["»]$/g, "");
  return PROGRAMME_TAG_EN[key] ?? tag;
}
